import React from "react"

import {
  IconButton,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core"
import { Delete as DeleteIcon } from "@material-ui/icons"
import { CustomEventProperty } from "@root/store/types"

const useStyles = makeStyles({
  table: {
    minWidth: 300,
  },
})

export interface Props {
  properties: CustomEventProperty[]
  onRemoveProperty(prop: CustomEventProperty): void
}

const CustomEventPropertiesTable: React.FC<Props> = ({
  properties,
  onRemoveProperty,
}) => {
  const classes = useStyles()

  return (
    <TableContainer>
      <Table className={classes.table} aria-label="Properties">
        <TableHead>
          <TableRow>
            <TableCell>Key</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Value</TableCell>
            <TableCell align="right" />
          </TableRow>
        </TableHead>
        <TableBody>
          {properties.map((prop) => (
            <TableRow
              key={prop.key}
              data-qa-selector={`custom-event-property-row-${prop.key}`}
            >
              <TableCell component="th">{prop.key}</TableCell>
              <TableCell>{prop.type}</TableCell>
              <TableCell>{prop.value}</TableCell>
              <TableCell align="right" padding="none" size="small">
                <IconButton
                  onClick={() => onRemoveProperty(prop)}
                  data-qa-selector="delete"
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default CustomEventPropertiesTable
